// Keep the shared writer out of CRM's initial page bundle.
export const loadWritingEditor = () => import('@zhiyue/intelligent-writing');
